import React from 'react';
import { KanbanSquare, Plus, Search } from 'lucide-react';
import { T } from '../constants';

/** Shown when the user has no applications at all. Kept compact on purpose. */
export const JobEmptyState = ({ onAdd, onFindJobs }) => (
  <div style={{
    background: T.surface, border: `1px solid ${T.line}`, borderRadius: T.radiusLg,
    padding: '44px 28px', textAlign: 'center', fontFamily: T.font,
    display: 'flex', flexDirection: 'column', alignItems: 'center',
  }}>
    <div style={{
      width: 54, height: 54, borderRadius: 15, marginBottom: 16,
      background: T.brandSoft, border: `1px solid ${T.brandBorder}`,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      <KanbanSquare size={24} color={T.brand} strokeWidth={1.9} />
    </div>

    <h3 style={{ margin: '0 0 7px', fontSize: 18, fontWeight: 800, color: T.ink, letterSpacing: -0.2 }}>
      Your job search starts here
    </h3>
    <p style={{ margin: '0 0 22px', fontSize: 13.5, color: T.muted, lineHeight: 1.6, maxWidth: 380 }}>
      Track applications, interviews, and offers in one place.
    </p>

    <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', justifyContent: 'center' }}>
      <button type="button" onClick={onAdd}
        style={{
          display: 'inline-flex', alignItems: 'center', gap: 7,
          background: T.brandGrad, color: 'white', border: 'none', borderRadius: 10,
          padding: '11px 22px', fontSize: 13.5, fontWeight: 700,
          cursor: 'pointer', fontFamily: T.font, boxShadow: T.shadowBrand,
          transition: 'transform 0.15s, box-shadow 0.15s',
        }}
        onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(239,29,40,0.45)'; }}
        onMouseLeave={e => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = T.shadowBrand; }}>
        <Plus size={15} strokeWidth={2.5} /> Add Your First Job
      </button>

      <button type="button" onClick={onFindJobs}
        style={{
          display: 'inline-flex', alignItems: 'center', gap: 7,
          background: T.surface, color: T.body, border: `1.5px solid ${T.line}`,
          borderRadius: 10, padding: '11px 20px', fontSize: 13.5, fontWeight: 600,
          cursor: 'pointer', fontFamily: T.font, transition: 'all 0.15s',
        }}
        onMouseEnter={e => { e.currentTarget.style.borderColor = '#CBD5E1'; e.currentTarget.style.background = T.canvas; }}
        onMouseLeave={e => { e.currentTarget.style.borderColor = T.line; e.currentTarget.style.background = T.surface; }}>
        <Search size={15} strokeWidth={2.2} /> Find Jobs
      </button>
    </div>
  </div>
);
